// extracted by mini-css-extract-plugin
export var addButton = "_oh-0";
export var border = "_oh-8";
export var check = "_oh-h";
export var danger = "_oh-6";
export var dropdownContainer = "_oh-1";
export var editModalBody = "_oh-j";
export var footerContainer = "_oh-i";
export var fullWidth = "_oh-a";
export var hide = "_oh-9";
export var icon = "_oh-3";
export var input = "_oh-7";
export var inputFlex = "_oh-b";
export var inputWrapper = "_oh-c";
export var manualFocus = "_oh-5";
export var optionButton = "_oh-4";
export var pillWrapper = "_oh-e";
export var pointer = "_oh-2";
export var showOverflow = "_oh-f";
export var tagsFlex = "_oh-d";
export var xButton = "_oh-g";